<template>
  <section class="invoice-preview-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <h2>{{ $t("accounting.patient") }}</h2>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <br>
          </b-col>
          <b-col
            md="3"
            cols="12"
          >
            <!-- <h4>Patient Name</h4> -->
            <b-form-group
              :label="$t('reception.patient-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="patientName"
                :placeholder="$t('reception.patient-name')"
                @keydown.enter="getPatientCards()"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
            cols="12"
          >
            <b-form-group
              :label="$t('accounting.invoice_status')"
              label-for="Type"
            >
              <v-select
                v-model="invoice_status"
                :options="['approved', 'pending', 'rejected', 'printed']"
                :placeholder="$t('accounting.invoice_status')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            cols="12"
          >
            <b-form-group
              :label="$t('common.from-date')"
              label-for="surgery_date"
            >
              <datepicker
                id="surgery_date"
                v-model="surgery_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12" md="2">
            <b-form-group
              :label="$t('common.pateint-card-id-status')"
              label-for="Type"
            >
              <v-select
                v-model="active_cards"
                :placeholder="$t('common.pateint-card-id-status')"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="activeListFilterOption"
                label="text"
                :reduce="(status) => status.value"
              />
            </b-form-group>
          </b-col> -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <h4></h4> -->
            <b-button
              class="mt-50"
              variant="primary"
              @click="getPatientCards()"
            >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" />
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table
              v-if="!loading"
              :items="patientCardsData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              class="position-relative"
              show-empty
              empty-text="No matching patients found"
            >
              <template #cell(phone)="data">
                <div
                  style="unicode-bidi: isolate"
                  :style="{
                    direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
                  }"
                >
                  {{ data.item.phone }}
                </div>
              </template>
              <template #cell(out-clinic)="data">
                <div>
                  {{ data.item.invoice_out_clinic.length }}
                </div>
              </template>
              <template #cell(surgery-deposit-invoices)="data">
                <div>
                  {{ data.item.invoice_insurance_surgery.length }}
                </div>
              </template>
              <template #cell(patient-surgery-invoices)="data">
                <div>
                  {{ data.item.invoice_patient_surgery.length }}
                </div>
              </template>
              <template #cell(is_active)="data">
                <b-badge
                  :variant="data.item.patient_card ? 'success' : 'danger'"
                >
                  {{ data.item.patient_card ? "Active" : "Not Active" }}
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <div
                  v-if="$store.state.app.permissions.includes('get-invoice')"
                  class="text-nowrap d-flex"
                >
                  <b-button
                    v-if="getLastPatientCardInfo(data.item)"
                    size="sm"
                    pill
                    :variant="
                      getLastPatientCardInfo(data.item).is_active ? 'success' : 'outline-secondary'
                    "
                    class="mb-75 mx-1"
                    @click="navigateToInvoices(data.item, getLastPatientCardInfo(data.item).id)"
                  >
                    {{ $t("hospital.preview-invoices") }}
                    <!-- <small
                      v-if="getLastPatientCardInfo(data.item).created_at"
                      class="ml-1"
                    >
                      ({{ formatCardDate(getLastPatientCardInfo(data.item).created_at) }})
                    </small> -->
                  </b-button>
                </div>
                <!-- <div class="text-nowrap d-flex">
                  <b-button
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'Reception-patient-preview',
                        params: { id: data.item.patient.id },
                      })
                    "
                  >
                    {{ $t("common.preview") }}
                  </b-button>

                  <b-button
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'out-clinic-invoices',
                        params: {
                          id: data.item.id,
                          name: data.item.patient.name,
                        },
                      })
                    "
                  >
                    {{ $t("reception.out-clinic-invoices") }}
                  </b-button>
                  <b-button
                    size="sm"
                    pill
                    variant="outline-primary"
                    class="mb-75"
                    @click="
                      $router.push({
                        name: 'patient-card-timeline',
                        params: { id: data.item.patient.id },
                      })
                    "
                    >{{ $t("reception.preview-timeline") }}</b-button
                  >
                </div> -->
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span
              class="text-muted"
            >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getPatientCards()"
          >
            <b-pagination
              v-model="page"
              :total-rows="dataCount"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  BFormInput,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIconSearch,
  BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import PatientSearch from '@/components/patientSearch.vue'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BIconSearch,
    PatientSearch,
    Datepicker,
  },
  data() {
    return {
      tableColumns: [
        { key: 'name', label: this.$t('common.name'), sortable: true },
        {
          key: 'patient_no',
          label: this.$t('accounting.patient_no'),
          sortable: true,
        },
        {
          key: 'birth_date',
          label: this.$t('reception.birth-date'),
          sortable: true,
        },
        {
          key: 'phone',
          label: this.$t('reception.phone'),
          sortable: true,
          class: 'text-nowrap',
        },

        // {
        //   key: "out-clinic",
        //   label: this.$t("hospital.outclinic-invoices"),
        //   sortable: true,
        // },
        // {
        //   key: "surgery-deposit-invoices",
        //   label: this.$t("hospital.surgery-deposit-invoices"),
        //   sortable: true,
        // },
        // {
        //   key: "patient-surgery-invoices",
        //   label: this.$t("hospital.patient-surgery-invoices"),
        //   sortable: true,
        // },
        {
          key: 'is_active',
          label: this.$t('common.status'),
          sortable: true,
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      patientCardsData: [],
      activeListFilterOption: [
        { text: 'Not Active', value: 0 },
        { text: 'Active', value: 1 },
      ],

      page: 1,
      totalRows: '',
      todayDate: '',
      take: 10,
      loading: false,
      selected: '',
      option: [],
      active_cards: null,
      patientName: null,
      invoice_status: null,
      surgery_date: null,
    }
  },
  watch: {
    patientName(newValue) {
      // Save patient name filter to sessionStorage whenever it changes
      sessionStorage.setItem('patientInvoices_nameFilter', newValue || '')
    },
    invoice_status(newValue) {
      // Save invoice status filter to sessionStorage whenever it changes
      sessionStorage.setItem('patientInvoices_statusFilter', newValue || '')
    },
    surgery_date(newValue) {
      // Save surgery date filter to sessionStorage whenever it changes
      sessionStorage.setItem(
        'patientInvoices_dateFilter',
        newValue ? this.formatDate(newValue) : '',
      )
    },
  },
  mounted() {
    // Restore filters from sessionStorage
    const savedNameFilter = sessionStorage.getItem(
      'patientInvoices_nameFilter',
    )
    if (savedNameFilter) {
      this.patientName = savedNameFilter
    }

    const savedStatusFilter = sessionStorage.getItem(
      'patientInvoices_statusFilter',
    )
    if (savedStatusFilter) {
      this.invoice_status = savedStatusFilter
    }

    const savedDateFilter = sessionStorage.getItem(
      'patientInvoices_dateFilter',
    )
    if (savedDateFilter) {
      // Convert date string back to Date object for the datepicker
      this.surgery_date = new Date(savedDateFilter)
    }

    this.getPatientCards()
  },
  methods: {
    // this is trmporary
    formatDate(wantedDate) {
      const date = new Date(wantedDate)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    formatCardDate(dateString) {
      if (!dateString) return ''
      // Extract date part from "2025-12-28 12:31:52 pm" format
      const datePart = dateString.split(' ')[0]
      // Format as YYYY-MM-DD (already in correct format)
      return datePart
    },
    findPatientCardIdFromInvoices(item) {
      // First check if patient_card exists at top level
      if (item.patient_card && item.patient_card.id) {
        return item.patient_card.id
      }

      // Search through all invoice arrays to find patient_card_id
      const invoiceArrays = [
        item.invoice_out_clinic,
        item.invoice_insurance_surgery,
        item.invoice_patient_surgery,
        item.invoice_patient_stay,
        item.invoice_patient_card_test,
        item.invoice_emergency,
        item.invoice_nicu,
        item.invoice_refund,
      ]

      for (const invoiceArray of invoiceArrays) {
        if (Array.isArray(invoiceArray) && invoiceArray.length > 0) {
          for (const invoice of invoiceArray) {
            if (invoice.patient_card_id) {
              return invoice.patient_card_id
            }
            // Also check if invoice has patient_card object
            if (invoice.patient_card && invoice.patient_card.id) {
              return invoice.patient_card.id
            }
          }
        }
      }

      return null
    },
    findPatientIdFromInvoices(item) {
      // First check if patient_card exists at top level
      if (item.patient_card && item.patient_card.patient_id) {
        return item.patient_card.patient_id
      }

      // Search through all invoice arrays to find patient_id
      const invoiceArrays = [
        item.invoice_out_clinic,
        item.invoice_insurance_surgery,
        item.invoice_patient_surgery,
        item.invoice_patient_stay,
        item.invoice_patient_card_test,
        item.invoice_emergency,
        item.invoice_nicu,
        item.invoice_refund,
      ]

      for (const invoiceArray of invoiceArrays) {
        if (Array.isArray(invoiceArray) && invoiceArray.length > 0) {
          for (const invoice of invoiceArray) {
            // Check if invoice has patient_card with patient_id
            if (invoice.patient_card && invoice.patient_card.patient_id) {
              return invoice.patient_card.patient_id
            }
          }
        }
      }

      // Fallback to item.id if no patient_id found
      return item.id
    },
    getPatientCardsWithInvoices(item) {
      const cardsMap = new Map()

      // Add the top-level patient_card if it exists
      if (item.patient_card && item.patient_card.id) {
        cardsMap.set(item.patient_card.id, {
          id: item.patient_card.id,
          is_active: item.patient_card.is_active,
          created_at: item.patient_card.created_at,
        })
      }

      // Search through all invoice arrays to find patient cards
      const invoiceArrays = [
        item.invoice_out_clinic,
        item.invoice_insurance_surgery,
        item.invoice_patient_surgery,
        item.invoice_patient_stay,
        item.invoice_patient_card_test,
        item.invoice_emergency,
        item.invoice_nicu,
        item.invoice_refund,
      ]

      for (const invoiceArray of invoiceArrays) {
        if (Array.isArray(invoiceArray) && invoiceArray.length > 0) {
          for (const invoice of invoiceArray) {
            let cardId = null
            let cardInfo = null

            // Check if invoice has patient_card_id
            if (invoice.patient_card_id) {
              cardId = invoice.patient_card_id
            }
            // Also check if invoice has patient_card object
            if (invoice.patient_card && invoice.patient_card.id) {
              cardId = invoice.patient_card.id
              cardInfo = {
                id: invoice.patient_card.id,
                is_active: invoice.patient_card.is_active,
                created_at: invoice.patient_card.created_at,
              }
            }

            if (cardId && !cardsMap.has(cardId)) {
              // If we have card info from the invoice, use it
              if (cardInfo) {
                cardsMap.set(cardId, cardInfo)
              } else {
                // Otherwise, create a basic entry (we'll try to find more info)
                cardsMap.set(cardId, {
                  id: cardId,
                  is_active: false, // Default to false if we don't have the info
                  created_at: null,
                })
              }
            }
          }
        }
      }

      // Convert map to array and sort by is_active (active cards first)
      return Array.from(cardsMap.values()).sort((a, b) => {
        if (a.is_active === b.is_active) return 0
        return a.is_active ? -1 : 1
      })
    },
    getLastPatientCardId(item) {
      const cards = this.getPatientCardsWithInvoices(item)
      if (!cards || cards.length === 0) {
        return null
      }
      // cards are sorted with active cards first; use the first as the 'last/primary' card
      return cards[0].id || null
    },
    getLastPatientCardInfo(item) {
      const cards = this.getPatientCardsWithInvoices(item)
      if (!cards || cards.length === 0) {
        return null
      }
      // cards are sorted with active cards first; use the first as the 'last/primary' card
      return cards[0] || null
    },
    navigateToInvoices(item, specificPatientCardId = null) {
      const patientId = this.findPatientIdFromInvoices(item)
      const patientCardId = specificPatientCardId || this.getLastPatientCardId(item)

      this.$router.push({
        name: 'acounting-invoices',
        params: {
          patientId,
          patientCardId,
          isPatientAccounting: 'false',
          isSurgeryAccounting: 'true',
        },
      })
    },
    async getPatientCards() {
      this.loading = true
      let url = `/patient/invoices?page=${this.page}&take=${this.take}&sort=-id&include=patientCard`

      if (this.patientName) {
        url += `&filter[name]=${this.patientName}`
      }
      if (this.surgery_date) {
        url += `&date=${this.formatDate(this.surgery_date)}`
      }
      if (this.invoice_status) {
        url += `&status=${this.invoice_status}`
      }
      await this.getList(url)
      for (const item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = ''
      }
      this.dataCount = this.all_data.total
      this.patientCardsData = this.all_data.data
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

#modal-add___BV_modal_content_ {
  width: 100% !important;
}

#modal-add {
  margin-left: -8% !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
